import { Application } from '../models';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const applicationsCreateActions = createActionGroup({
  source: 'Einreichung - applications create',
  events: {
    'Create': props<{ containerId: string }>(),
    'Create success': props<{ application: Pick<Application, 'antragsId' | 'concurrency' | 'containerId'> }>(),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    'Create failed': props<{ error: any }>(),
    'Clear store': emptyProps(),
  },
});
